import {
    GENERATE_PRINT_ORDER_LOADING_DONE,
    GENERATE_PRINT_ORDER_LOADING,
} from '../../actions';

const INITIAL_STATE = {
    loading: false,
};

const generateOrder = (state = INITIAL_STATE, { type }) => {
    switch (type) {
        case GENERATE_PRINT_ORDER_LOADING:
            return {
                ...state,
                loading: true,
            };

        case GENERATE_PRINT_ORDER_LOADING_DONE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};
export default generateOrder;
